import { render, staticRenderFns } from "./PickupPointDetailView.vue?vue&type=template&id=3b43299f&"
import script from "./PickupPointDetailView.vue?vue&type=script&lang=js&"
export * from "./PickupPointDetailView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports